import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5l0 14","key":"svg-0"}],["path",{"d":"M5 12l14 0","key":"svg-1"}]]

const IconPlus = createReactComponent('outline', 'plus', 'Plus', __iconNode);

export default IconPlus;